/* global $ */

const {checkContentSize} = require('./responsive')
const env = require('./env')

const assetKeys = [
    'hero_output',
    'hero_output_mobile',
    'step1_output',
    'step1_output_mobile',
    'step2_output',
    'step2_output_mobile',
    'step3_output',
    'step3_output_mobile',
    'step4_output',
    'step4_output_mobile',
]

module.exports = data => {
    const isNewApp = env.dev || data.activeAppVersion === 2
    const {assets} = data

    $('body').addClass(`app-version-${isNewApp ? 2 : 1}`)
    $('title').text(`${data.name} | Names & Faces`)

    $('#content-wrap h1').append(
        $('<img />').attr('src', data.logo.url)
        .attr('alt', data.name)
        .attr('title', data.name)
    )

    if (data.landerLogoHeight) {
        $('#content-wrap h1').find('img')
            .height(data.landerLogoHeight)
            .css('max-height', 'none')
    }

    const mobileImageUrl = isNewApp && data.lander_image_new_r ? data.lander_image_new_r : data.lander_image

    $('.mobile-image-banner')
    .css('background-image', `url(${mobileImageUrl})`)

    // Check for a complete set of assets for the features slider
    let hasCompleteSet = true
    $.each(assetKeys, (index, key) => {
        if (!assets[key]) {
            hasCompleteSet = false
            return false
        }
    })

    if (hasCompleteSet) {
        $.each(assetKeys, (index, key) => {
            $(`#${key}`).attr('src', assets[key].url)
        })

        if (isNewApp) {
            $('.mobile-image-banner').css('background-image', `url(${assets.hero_output_mobile.url})`)
        }

        $(".features").removeClass('features-hidden')
        $(".discover").css('display', 'inline-block')
    }

    $("#loading-div").fadeOut(400, () => {
        $("#content-wrap, .features, footer").fadeInCss()

        checkContentSize()
    })
}



/** WEBPACK FOOTER **
 ** ./js/credentials/applyOrganisationAssets.js
 **/